export const SET_DASHBOARD_RANGE = 'SET_DASHBOARD_RANGE'

// Formát shodný s DateTimeField (showTimeSelect): "yyyy-MM-ddTHH:mm" (lokální čas, bez TZ)
const pad = (n) => String(n).padStart(2, "0");
const fmtLocal = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
const todayStart = () => { const d = new Date(); d.setHours(0, 0, 0, 0); return fmtLocal(d); };
const todayEnd = () => { const d = new Date(); d.setHours(23, 59, 0, 0); return fmtLocal(d); };

export default function dashboardRange(
    state = {from: todayStart(), to: todayEnd()},
    action
) {
    switch (action.type) {
        case SET_DASHBOARD_RANGE:
            return {from: action.payload.from, to: action.payload.to};
        default:
            return state;
    }
}
